import * as React from 'react';
import {cancel} from '@sail/icons/react/Icon';
import {Icon} from './Icon';
import {view} from '../view';
import {css} from '../css';

const buttonReset = css({
  backgroundColor: css.value('transparent'),
  border: css.value('0'),
  padding: 0,
  userSelect: css.value('none'),
});

// replace this with a CloseButton theme object once we
// build a more reusable CloseButton
const buttonStyles = css({
  cursor: css.value('pointer'),
  padding: 50,
  height: 250,
  // makes sure line height doesn't get reset by normalize styles in sailpen SAIL-2663
  lineHeight: css.value('normal'),

  '& svg': {
    fill: css.value('$color.neutral400'),
    height: css.value('12px'),
    width: css.value('12px'),
  },

  '&:hover svg': {
    fill: css.value('$color.neutral500'),
  },

  '&:focus svg': {
    fill: css.value('$color.neutral500'),
  },

  '&:active svg': {
    fill: css.value('$color.neutral600'),
  },
});

export interface CloseButtonProps {
  /**
   * @external
   */
  onDismiss?: () => void;
}

export const CloseButton = view.button.create<CloseButtonProps>(
  function CloseButton({onDismiss, ...props}, View) {
    return (
      <View
        aria-label="close"
        uses={[buttonReset, buttonStyles, props]}
        onClick={onDismiss}
        type="button"
      >
        <Icon icon={cancel} />
      </View>
    );
  },
);
